import { BrandId, localeSpecific } from '../../utils/override';
import { config } from './config';
import { Translations as staticText } from './i18n/dashboard';

type LocalizeFormResult = {
  form: {
    genderLabel: string;
    maritalStatusLabel: string;
    occupationTypeLabel: string;
    offPeakVehicleLabel: string;
    ageLabel: string;
    ncdLabel: string;
    offenceFreeLabel: string;
    nocLabel: string;
    brandLabel: string;
    modelLabel: string;
    yearLabel: string;
    variantLabel: string;
    drivingExperienceLabel: string;
    genderOptions: { value: string; label: string }[];
    maritalStatusOptions: { value: string; label: string }[];
    occupationTypeOptions: { value: string; label: string }[];
    offPeakVehicleOptions: { value: string; label: string }[];
    driverAgeOptions: { value: string; label: string }[];
    drivingExperienceOptions: { value: string; label: string }[];
    bolttechDrivingExperienceOptions: { value: string; label: string }[];
    offfenceFreeOptions: { value: string; label: string }[];
    nocOptions: { value: string; label: string }[];
    bolttechNocOptions: { value: string; label: string }[];
    offenceFreeHelpText: string;
  };
  sidebar: {
    title: string;
    subtitle: string;
    carDetailsSubtitle: string;
    buttonText: string;
  };
};

export function localizeForm(lang: string, brand: BrandId): LocalizeFormResult {
  const sidebarTitle = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.title,
  }).get(lang);

  const sidebarSubtitle = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.subtitle,
  }).get(lang);

  const carDetailsSubtitle = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.carDetailsSubtitle,
  }).get(lang);

  const updateButtonText = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.updateButton,
  }).get(lang);

  const genderLabel = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.gender.label,
  }).get(lang);

  const genderOptions = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.gender.values,
  }).get(lang);

  const maritalStatusLabel = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.maritalStatus.label,
  }).get(lang);

  const maritalStatusOptions = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.maritalStatus.values,
  }).get(lang);

  const occupationTypeLabel = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.occupationType.label,
  }).get(lang);

  const occupationTypeOptions = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.occupationType.values,
  }).get(lang);

  const offPeakVehicleLabel = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.offPeakVehicle.label,
  }).get(lang);

  const offPeakVehicleOptions = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.offPeakVehicle.values,
  }).get(lang);

  const ageLabel = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.age.label,
  }).get(lang);

  const drivingExperienceLabel = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.drivingExperience.label,
  }).get(lang);

  const ncdLabel = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.ncd,
  }).get(lang);

  const offenceFreeLabel = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.offenceFree.label,
  }).get(lang);

  const nocLabel = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.noc.label,
  }).get(lang);

  const { driverAgeOptions } = config()[brand as BrandId];

  const drivingExperienceOptions = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.drivingExperience.values,
  }).get(lang);

  const bolttechDrivingExperienceOptions = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.drivingExperience
      .bolttechValues,
  }).get(lang);

  const offfenceFreeOptions = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.offenceFree.values,
  }).get(lang);

  const nocOptions = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.noc.values,
  }).get(lang);

  const bolttechNocOptions = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.noc.bolttechValues,
  }).get(lang);

  const brandLabel = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.brand,
  }).get(lang);

  const modelLabel = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.model,
  }).get(lang);

  const yearLabel = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.year,
  }).get(lang);

  const variantLabel = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.variant,
  }).get(lang);

  const offenceFreeHelpText = localeSpecific({
    ...staticText.sidebars.editQuoteSidebar.form.offenceFree.helpText,
  }).get(lang);

  return {
    sidebar: {
      title: sidebarTitle,
      subtitle: sidebarSubtitle,
      carDetailsSubtitle,
      buttonText: updateButtonText,
    },
    form: {
      genderLabel,
      genderOptions,
      maritalStatusLabel,
      maritalStatusOptions,
      occupationTypeLabel,
      offPeakVehicleLabel,
      ageLabel,
      drivingExperienceLabel,
      ncdLabel,
      offenceFreeLabel,
      nocLabel,
      occupationTypeOptions,
      offPeakVehicleOptions,
      driverAgeOptions,
      drivingExperienceOptions,
      bolttechDrivingExperienceOptions,
      offfenceFreeOptions,
      nocOptions,
      bolttechNocOptions,
      brandLabel,
      modelLabel,
      yearLabel,
      variantLabel,
      offenceFreeHelpText,
    },
  };
}
